/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HomeAgendaItem } from './HomeAgendaItem';

export type HomeAgendaResponse = {
    items: Array<HomeAgendaItem>;
    personal_status?: HomeAgendaResponse.personal_status;
    calendar?: HomeAgendaResponse.calendar;
};

export namespace HomeAgendaResponse {

    export enum personal_status {
        OK = 'ok',
        UNAVAILABLE = 'unavailable',
    }

    export enum calendar {
        LINKED = 'linked',
        NOT_LINKED = 'not_linked',
        NO_ACCESS = 'no_access',
        ERROR = 'error',
        UNKNOWN = 'unknown',
    }


}

